import { render } from "./settings-create-user.vue?vue&type=template&id=07946862"
import script from "./settings-create-user.vue?vue&type=script&lang=js"
export * from "./settings-create-user.vue?vue&type=script&lang=js"

import "./settings-create-user.vue?vue&type=style&index=0&id=07946862&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__